import styled, {css} from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from 'react-native-fast-image';

interface ItemName {
  capitalize?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const UserWrapper = styled.TouchableOpacity.attrs(() => ({
  activeOpacity: 1,
}))`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const UserInfoWrapper = styled.View`
  align-items: center;
  flex-direction: row;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
  margin: 0 -24px;
  padding: 0 24px;
  padding-bottom: ${RFValue(12)}px;
`;

export const UserInfo = styled.View`
  flex-direction: column;
  margin-left: ${RFValue(12)}px;
  justify-content: flex-start;
  flex: 1;
`;

export const PhotoContainer = styled.TouchableOpacity``;

export const IconContainer = styled.View`
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  border-radius: ${RFValue(50)}px;
  position: absolute;
  z-index: 1;
  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.colors.mask};
`;

export const Icon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(14)}px;
`;

export const Photo = styled(FastImage)`
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  border-radius: ${RFValue(50)}px;
`;

export const UserGreeting = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const UserName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  width: 100%;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Infos = styled.View`
  margin: 0 -24px;
  margin-top: ${RFValue(20)}px;
`;

export const Item = styled.View``;

export const Button = styled.TouchableOpacity`
  flex-direction: row;
  padding: 0 ${RFValue(24)}px;
  height: ${RFValue(50)}px;
  align-items: center;
  justify-content: space-between;
`;

export const ItemContainer = styled.View``;

export const Label = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
`;

export const ItemName = styled.Text<ItemName>`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  ${({capitalize}) =>
    capitalize &&
    css`
      text-transform: capitalize;
    `}
`;

export const DeleteAccountButtonContainer = styled.View`
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
`;

export const DeleteAccountButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const DeleteAccountButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;
